import { ANALISE_IMAGEM_LOAD, ANALISE_IMAGEM_UNLOAD, ANALISE_IMAGEM_ALL_COMPANIES_LOAD, ANALISE_IMAGEM_ALL_FINANCIAL_LOAD, UF_SYSTEM_LOAD } from "../../actions/Constants";

const INITIAL_STATE = { all: [], allCompanies: [], allFinancial: [], ufSystem: [] };

export default function analiseImagem(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ANALISE_IMAGEM_LOAD:
      return {
        ...state,
        all: action.payload ? action.payload : [],
      };
    case ANALISE_IMAGEM_ALL_COMPANIES_LOAD:
      return {
        ...state,
        allCompanies: action.payload ? action.payload : [],
      };
    case ANALISE_IMAGEM_ALL_FINANCIAL_LOAD:
      return {
        ...state,
        allFinancial: action.payload ? action.payload : [],
      };
    case UF_SYSTEM_LOAD:
      return {
        ...state,
        ufSystem: action.payload ? action.payload : [],
      };
    case ANALISE_IMAGEM_UNLOAD:
      return INITIAL_STATE;
    default:
      return state;
  }
}
